// Local development uses the Create React App proxy configured in setupProxy.js.
// Hosted builds provide REACT_APP_API_BASE_URL through build-dev.bat/build-prod.bat.
const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL?.replace(/\/$/, '');

if (process.env.NODE_ENV === 'production' && !configuredBaseUrl) {
  throw new Error('REACT_APP_API_BASE_URL is required for hosted builds');
}

export const apiConfig = {
  baseUrl: configuredBaseUrl || '/dev',
  
  endpoints: {
    health: '/health',
    upload: '/api/upload',
    tasks: '/api/tasks',
    defaultPrompts: '/api/prompts/defaults',
    decks: '/api/decks',
    deck: (deckId: string) => `/api/deck/${deckId}`,
    deckStatus: (deckId: string) => `/api/deck/${deckId}/status`,
    slides: (deckId: string) => `/api/deck/${deckId}/slides`,
    slide: (deckId: string, slideNumber: number) => `/api/deck/${deckId}/slide/${slideNumber}`,
    updateFindingAddressed: (deckId: string, slideNumber: number) => `/api/deck/${deckId}/slide/${slideNumber}/finding/addressed`,
    deleteDeck: (deckId: string) => `/api/deck/${deckId}`,
    chat: (deckId: string) => `/api/chat/${deckId}/message`,
    chatHistory: (deckId: string) => `/api/chat/${deckId}/history`,
    reanalyze: (deckId: string) => `/api/chat/${deckId}/reanalyze`,
    attachmentPresign: (deckId: string) => `/api/chat/${deckId}/attachment/presign`,
    export: (deckId: string) => `/api/export/${deckId}`,
    exportStatus: (deckId: string, reportId: string) => `/api/export/${deckId}/${reportId}`,
  },
};

export default apiConfig;

